import { useEffect } from "react";
import { useState } from "react";
import CandodateService from "../../Service.js/CandidateService";
import { Button } from "antd";
import { Link } from "react-router-dom";


const CandidateVideoPlayer = () => {
    const [isVideoDetails, setIsVideoDetails] = useState();

    const recorderedVideo = async () => {
        await CandodateService.getRecordedDetails()
            .then(
                (response) => {
                    console.log("response", response.data.data);
                    setIsVideoDetails(response.data.data);
                }
            )
            .catch((error) => {
            });

    }
    useEffect(() => {
        recorderedVideo()
    }, [])

    return (
        <div className="flex flex-wrap justify-center items-center mt-6 pageContent w-full scrollbar-hide">
            <div>
                <div>
                    <video className="w-full h-[500px]" controls      style={{ transform: "scaleX(-1)" }} 
                     disablePictureInPicture 
                     controlsList="nodownload nofullscreen noremoteplayback" 
                        src={isVideoDetails?.profile_video_absolute_url} type="video/mp4" />

                </div>
                <div>
                    <div className="flex flex-wrap justify-end mt-6 mb-10">
                        <div className="flex flex-wrap justify-between">
                            <div className="px-4">
                                <Link to={`/profile`}>
                                    <Button

                                        className="rounded-full border-red-500 bg-white text-red-500 text-base font-semibold">
                                        Cancel
                                    </Button>
                                </Link>
                            </div>
                            <div>

                                <Link to={`/videoRecording/${isVideoDetails?.id}`} className="">
                                    <Button

                                        className="rounded-full bg-red-500 text-white  text-base font-semibold ">
                                        Upload new Video
                                    </Button>
                                </Link>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CandidateVideoPlayer